const require_rolldown_runtime = require('./_virtual/rolldown_runtime.cjs');

//#region src/cookie.ts
var cookie_exports = /* @__PURE__ */ require_rolldown_runtime.__export({ preview: () => preview });
/**
* The well-known name of the cookie used to store a Prismic preview session's
* ref.
*/
const preview = "io.prismic.preview";

//#endregion
Object.defineProperty(exports, 'cookie_exports', {
  enumerable: true,
  get: function () {
    return cookie_exports;
  }
});
exports.preview = preview;
//# sourceMappingURL=cookie.cjs.map